import auth from '@/store/modules/auth'
import leftSidebar from '@/store/modules/left-sidebar'
import directory from '@/store/modules/directory'
import kindsSport from '@/store/modules/kinds-sport'
import kindsSportItem from '@/store/modules/kinds-sport-item'
import sportsObjects from '@/store/modules/sports-objects'
import sportObjectEdit from '@/store/modules/sports-objects-edit'
import sportObjectDelete from '@/store/modules/sports-objects-delete'
import athleteCreate from '@/store/modules/athlete-create'
import athletes from '@/store/modules/athletes'
import athleteEdit from '@/store/modules/athlete-edit'
import athleteDelete from '@/store/modules/athlete-delete'
import athleteVerified from '@/store/modules/athlete-verified'
import trainers from '@/store/modules/trainers'
import trainingGroups from '@/store/modules/training-groups'
import groupsAthletes from '@/store/modules/groups-athletes'
import groupsTrainers from '@/store/modules/groups-trainers'
import schoolsFederations from '@/store/modules/schools-federations'
import trainings from '@/store/modules/trainings'
import trainingsTemplate from '@/store/modules/trainings-template'
import roles from '@/store/modules/roles'
import users from '@/store/modules/users'
import sportEvents from '@/store/modules/sport-events'
import competition from '@/store/modules/competition'
import errors from '@/store/modules/errors'
import calendarPlan from '@/store/modules/calendar-plan'
import athleteResult from '@/store/modules/athlete-result'
import athleteScholarship from '@/store/modules/scholarship'
import analytics from '@/store/modules/analytics'
import allUsers from '@/store/modules/all-users'
import toggleAthleteVerified from '@/store/modules/toggle-athlete-verified'
import athleteDeactivate from '@/store/modules/athlete-deactivate'
import athleteActivate from '@/store/modules/athlete-activate'
import registerUser from '@/store/modules/register-user'
import registerAdmin from '@/store/modules/register-admin'
import exist from '@/store/modules/exist'
import login from '@/store/modules/login'
import tariff from '@/store/modules/tariff'
import excel from '@/store/modules/excel'
import parents from '@/store/modules/parents'
import resetPassword from '@/store/modules/reset-password'
import finance from '@/store/modules/finance'
import competitionFinances from '@/store/modules/competition-finances'
import sportsObjectsList from '@/store/modules/sports-objects-list'
import sportsObjectsSearch from '@/store/modules/sports-objects/sports-objects-search'
import sportsSchoolsMore from '@/store/modules/sports-schools-more'
import kindsSports from '@/store/modules/kinds-sports'
import feedback from '@/store/modules/feedback'
import enrollment from '@/store/modules/enrollment'
import reporting from '@/store/modules/reporting'
import eventsSearch from '@/store/modules/events-search/events-search'
import trainerResult from '@/store/modules/trainer-result'
import removalRequests from '@/store/modules/removal-requests'
import feedbackTrainers from '@/store/modules/feedback-trainers'
import documents from '@/store/modules/documents'
import news from '@/store/modules/news'
import stores from '@/store/modules/stores'
import sheltersMap from '@/store/modules/shelters-map'
import competitionTrainers from '@/store/modules/competitions-trainers/'
import competitionsAthletes from '@/store/modules/competitions-athletes'

import sportsEventsTrainers from '@/store/modules/sports-events-trainers/'
import sportsEventsAthletes from '@/store/modules/sports-events-athletes/'
import ntzTemplate from '@/store/modules/ntz-template'
import competitiveActivity from '@/store/modules/competitive-activity'
import еventsCompetitionsSearch from '@/store/modules/еvents-сompetitions-search'
import athleteIsBlocked from '@/store/modules/athlete-is-blocked'
import actionsMagazine from '@/store/modules/actions-magazine'
import sportsClubsMore from '@/store/modules/sports-clubs-more'

export default {
  auth,
  leftSidebar,
  directory,
  kindsSport,
  kindsSportItem,
  sportsObjects,
  sportObjectEdit,
  sportObjectDelete,
  athleteCreate,
  athletes,
  athleteEdit,
  athleteDelete,
  athleteVerified,
  ...trainers,
  ...trainingGroups,
  ...groupsAthletes,
  ...groupsTrainers,
  schoolsFederations,
  ...trainings,
  ...trainingsTemplate,
  ...roles,
  ...users,
  ...sportEvents,
  ...competition,
  ...errors,
  ...calendarPlan,
  ...athleteResult,
  ...athleteScholarship,
  ...analytics,
  ...allUsers,
  toggleAthleteVerified,
  athleteDeactivate,
  athleteActivate,
  registerUser,
  registerAdmin,
  exist,
  login,
  ...tariff,
  ...excel,
  ...parents,
  resetPassword,
  ...finance,
  ...competitionFinances,
  sportsObjectsList,
  sportsObjectsSearch,
  sportsSchoolsMore,
  sportsClubsMore,
  ...kindsSports,
  ...feedback,
  ...enrollment,
  ...reporting,
  eventsSearch,
  ...trainerResult,
  ...removalRequests,
  ...feedbackTrainers,
  ...documents,
  ...news,
  ...stores,
  ...sheltersMap,
  ...competitionTrainers,
  ...competitionsAthletes,
  ...sportsEventsTrainers,
  ...sportsEventsAthletes,
  ...ntzTemplate,
  ...competitiveActivity,
  ...еventsCompetitionsSearch,
  athleteIsBlocked,
  ...actionsMagazine,
}
